import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { BILLS_KEY } from "./types";
import { tt } from "../../utils/i18n/i18n";
import { setError, setLoading } from "../../redux/actions/app";
import { useAccountToDisplaySelector } from "../../redux/actions/user";
import BillsTableComponent from "./components/BillsTableComponent";
import KC_Separator from "../../designsystem/KC_Separator/KC_Separator";
import { KC_Sizes } from "../../designsystem/ds_commons";
import PaymentCards from "../21_BusinessProfile/components/cards/PaymentCards";
import { fetchBills } from "./api";

export default function Bills() {
  const { accountToDisplay } = useAccountToDisplaySelector();
  const dispatch = useDispatch();

  const { data, isLoading, error, refetch } = useQuery(
    BILLS_KEY,
    async () => await fetchBills(accountToDisplay?.token),
    {
      enabled: !!accountToDisplay?.token
    }
  );

  if (error) {
    dispatch(setError(tt("api_error")));
  }

  useEffect(() => {
    dispatch(setLoading(isLoading));
  }, [isLoading]);

  useEffect(() => {
    if (!accountToDisplay?.token) {
      return;
    }
    void refetch();
  }, [accountToDisplay?.trackingID, accountToDisplay?.token]);

  return (
    <div className="d-flex flex-column p-4 dashboard-v2">
      {data != null && (
        <>
          <BillsTableComponent
            currencySubUnits={data.currencySubUnits}
            bills={data?.subscription || []}
            isSubscription={true}
            displayAccountSelector={true}
            businessUserId={accountToDisplay?.email}
            onBillPaid={() => void refetch()}
          />
          <KC_Separator size={KC_Sizes.l} />
          <BillsTableComponent
            currencySubUnits={data.currencySubUnits}
            bills={data?.manual || []}
            displayAccountSelector={false}
            businessUserId={accountToDisplay?.email}
            onBillPaid={() => void refetch()}
          />
        </>
      )}
      <KC_Separator size={KC_Sizes.l} />
      <div className="card p-4" id="payment-cards">
        <h5 className="card-title">{tt("means_of_payment")}</h5>
        <div>
          <PaymentCards />
        </div>
      </div>
    </div>
  );
}
